import Ajv from 'ajv';
import addFormats from 'ajv-formats';
import betterAjvErrors from 'better-ajv-errors';
import addCustomKeywords from './addCustomKeywords';
import getPackageJsonSchema from './schema/packageJSON';

export default function validatePackageJSON(
  pkg: Record<string, unknown>,
  pkgPath: string,
  context: {
    projectRoot: string;
  },
) {
  const ajv = new Ajv({ allErrors: true });
  addFormats(ajv);
  addCustomKeywords(ajv, context);
  const schema = getPackageJsonSchema(context);
  const validate = ajv.compile(schema);
  if (!validate(pkg)) {
    const output = betterAjvErrors(schema, pkg, validate.errors ?? [], {
      indent: 2,
    });

    const error = new Error(`package.json invalid (${pkgPath}); \n${output}`);
    (error as any).isValidationError = true;
    // This throws and bubbles all the way up to the user
    throw error;
  }
}
